import React, { /* useEffect, */ useState } from 'react';
import PageHeader from 'components/common/PageHeader';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { contextApp, contextPayment } from 'context';
import { currency } from 'helpers/utils';

const PaymentData = () => {
 const { contract, contracts, payerDetails } = contextPayment();
 const [client] = useState(
  contract?.receivers
   ?.find(e => e.docType === payerDetails?.docType && e.docNumber === payerDetails?.docNumber)
   ?.arrayName.join(' ')
   .toLowerCase() ?? 'Sin nombre'
 );
 const {
  config: { isRTL }
 } = contextApp();

 return (
  <PageHeader
   image={contract?.project?.logo}
   title={
    <div className="text-capitalize">
     {contract?.project?.detail
      ? contract?.project?.detail
      : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4)}
    </div>
   }
   classDesp="text-capitalize"
   description={client}
   className="mb-3"
  >
   <Dropdown>
    <Dropdown.Toggle variant="link" size="sm" className="ps-0" id="#change-plan">
     Cambiar contrato
    </Dropdown.Toggle>
    <Dropdown.Menu className="py-3" align={isRTL ? 'end' : 'start'} style={{ minWidth: '15rem' }}>
     {contracts?.map((e, i) => (
      <Dropdown.Item key={i} as="div" className="px-3 py-2">
       <span className="d-flex justify-content-between fs--1 text-black">
        <span className="fw-semi-bold">{e?._id?.slice(-4)}</span>
        <span>{currency(e?.amount, true)}</span>
       </span>
       {e?.products?.map((p, i) => (
        <ul className="list-unstyled ps-1 my-2 fs--1" key={i}>
         <li>
          <FontAwesomeIcon icon="circle" transform="shrink-11" />
          <span className="ms-1">
           Lote: {p?.num}, con una area de {p?.area}
          </span>
         </li>
        </ul>
       ))}
       <p className="fs--2 mb-0">
        Separado en{' '}
        <Link to="#!">
         {new Date(e?.start).toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
         })}
        </Link>
       </p>
      </Dropdown.Item>
     ))}
    </Dropdown.Menu>
   </Dropdown>
  </PageHeader>
 );
};

export default PaymentData;
